// src/services/SolicitorService.js
import ApiService from '../base/BaseApiService';

// 募集人を取得
export const fetchSolicitor = async (id) => {
  try {
    return await ApiService.get(`/solicitors/${id}`);
  } catch (error) {
    console.error('Error fetching solicitors:', error);
    throw error;
  }
};

// 新しい募集人を作成
export const createSolicitor = async (solicitorData) => {
  try {
    return await ApiService.post('/solicitors/', solicitorData);
  } catch (error) {
    console.error('Error creating solicitor:', error);
    throw error;
  }
};

// 募集人を更新
export const updateSolicitor = async (id, solicitorData) => {
  try {
    return await ApiService.put(`/solicitors/${id}`, solicitorData);
  } catch (error) {
    console.error('Error updating solicitor:', error);
    throw error;
  }
};

// 募集人を検索
export const searchSolicitor = async (searchData) => {
  try {
    return await ApiService.post('/solicitors/search', searchData);
  } catch (error) {
    console.error('Error registering solicitor:', error);
    throw error;
  }
};

// CSVから募集人をインポート
export const importSolicitorsFromCSV = async (agencyId, file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const config = {
      headers: {
        'Content-Type': undefined, // ブラウザに境界線を自動設定させる
      }
    };

    console.log('送信ファイル情報:', {
      name: file.name,
      size: file.size,
      type: file.type
    });
    
    return await ApiService.post(
      `/solicitors/bulk-upload/${agencyId}`, 
      formData,
      config
    );
  } catch (error) {
    console.error('Error importing solicitors from CSV:', error);
    
    if (error.response) {
      console.error('サーバーレスポンス:', error.response.data);
      console.error('ステータスコード:', error.response.status);
    } else if (error.request) {
      console.error('リクエストエラー:', error.request);
    } else {
      console.error('その他のエラー:', error.message);
    }

    throw error;
  }
};

// 募集人をCSVにエクスポート
export const exportSolicitorsToCSV = async (agencyId) => {
  try {
    await ApiService.getBlob(
      `/solicitors/download/${agencyId}`, 
      {}, 
      `solicitors_${agencyId}.csv`
    );
    return true;
  } catch (error) {
    console.error('募集人CSVのエクスポートエラー:', error);
    throw error;
  }
};